(function () {
  if (!document.body.classList.contains('template-product')) return;

  var pdp = document.querySelector('[data-lux-pdp]');
  if (!pdp) return;

  var productJsonEl = pdp.querySelector('[data-lux-product-json]');
  var product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
  var form = pdp.querySelector('[data-lux-product-form]');
  var variantInput = pdp.querySelector('[data-lux-variant-id]');
  var priceEl = pdp.querySelector('[data-lux-price]');
  var compareEl = pdp.querySelector('[data-lux-compare-price]');
  var stickyPrice = pdp.querySelector('[data-lux-sticky-price]');
  var atcBtn = pdp.querySelector('[data-lux-atc-btn]');
  var mainWrap = pdp.querySelector('[data-lux-gallery-main-wrap]');
  var mainSlot = pdp.querySelector('[data-lux-gallery-main]');
  var mainImg = pdp.querySelector('[data-lux-gallery-image]');

  function showGalleryImage(src, alt) {
    if (!mainSlot) return;
    var video = mainSlot.querySelector('video');
    if (video) video.remove();
    if (!mainImg) {
      mainImg = document.createElement('img');
      mainImg.setAttribute('data-lux-gallery-image', '');
      mainImg.loading = 'eager';
      mainSlot.appendChild(mainImg);
    }
    mainImg.hidden = false;
    mainImg.src = src;
    if (alt) mainImg.alt = alt;
  }

  function showGalleryVideo(src) {
    if (!mainSlot) return;
    if (mainImg) mainImg.hidden = true;
    var video = mainSlot.querySelector('video');
    if (!video) {
      video = document.createElement('video');
      video.className = 'lux-gallery__video';
      video.controls = true;
      video.playsInline = true;
      video.preload = 'metadata';
      mainSlot.appendChild(video);
    }
    if (video.getAttribute('src') !== src) {
      video.pause();
      video.src = src;
      video.load();
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getSelectedOptions() {
    var options = [];
    pdp.querySelectorAll('[data-lux-option-btn].is-active').forEach(function (btn) {
      options.push(btn.getAttribute('data-option-value'));
    });
    if (!options.length && product && product.options) {
      product.options.forEach(function (opt, i) {
        var active = pdp.querySelector('[data-lux-option-btn][data-option-index="' + i + '"].is-active');
        if (active) options.push(active.getAttribute('data-option-value'));
      });
    }
    return options;
  }

  function findVariant() {
    if (!product) return null;
    var selected = getSelectedOptions();
    return product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
  }

  function getMapPriceCents() {
    var raw = pdp.getAttribute('data-map-price-cents');
    var cents = raw ? parseInt(raw, 10) : 0;
    return Number.isFinite(cents) && cents > 0 ? cents : 0;
  }

  function shouldShowComparePrice(variant) {
    var mapCents = getMapPriceCents();
    if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) return false;
    if (mapCents > 0 && variant.compare_at_price < mapCents) return false;
    return true;
  }

  function updateVariant(variant) {
    if (!variant || !variantInput) return;
    variantInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      var showCompare = shouldShowComparePrice(variant);
      compareEl.style.display = showCompare ? '' : 'none';
      compareEl.hidden = !showCompare;
      if (showCompare) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
      }
    }
    var saveBadge = pdp.querySelector('[data-lux-save-badge]');
    if (saveBadge) {
      var showSave = shouldShowComparePrice(variant);
      saveBadge.style.display = showSave ? '' : 'none';
      saveBadge.hidden = !showSave;
      if (showSave) {
        saveBadge.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price);
      }
    }
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
    if (variant.featured_image && mainImg) {
      var src = variant.featured_image.src;
      var skipFirst = pdp.getAttribute('data-skip-first-image') === 'true';
      var firstMediaSrc = product && product.media && product.media[0] ? product.media[0].preview_image && product.media[0].preview_image.src : '';
      if (skipFirst && product && product.media && product.media.length > 1) {
        var variantSrcBase = src.split('?')[0];
        var firstSrcBase = firstMediaSrc ? firstMediaSrc.split('?')[0] : '';
        if (!firstSrcBase || variantSrcBase === firstSrcBase) {
          var second = product.media[1];
          if (second && second.preview_image) {
            src = second.preview_image.src;
          }
        }
      }
      if (src.indexOf('cdn.shopify.com') !== -1) {
        mainImg.src = src.split('?')[0] + '?width=1200';
      } else {
        mainImg.src = src;
      }
    }
  }

  pdp.querySelectorAll('[data-lux-option-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = btn.getAttribute('data-option-index');
      pdp.querySelectorAll('[data-lux-option-btn][data-option-index="' + idx + '"]').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      var label = pdp.querySelector('[data-lux-option-label="' + idx + '"]');
      if (label) label.textContent = '— ' + btn.getAttribute('data-option-value');
      updateVariant(findVariant());
    });
  });

  /* Gallery */
  pdp.querySelectorAll('[data-lux-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mediaType = thumb.getAttribute('data-media-type');
      if (mediaType === 'video') {
        showGalleryVideo(thumb.getAttribute('data-video-src'));
      } else {
        showGalleryImage(thumb.getAttribute('data-src'));
      }
      pdp.querySelectorAll('[data-lux-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* Qty */
  var qty = 1;
  var qtyDisplay = pdp.querySelector('[data-lux-qty-display]');
  var qtyInput = pdp.querySelector('[data-lux-qty-input]');
  function setQty(n) {
    qty = Math.max(1, n);
    if (qtyDisplay) qtyDisplay.textContent = qty;
    if (qtyInput) qtyInput.value = qty;
  }
  var minus = pdp.querySelector('[data-lux-qty-minus]');
  var plus = pdp.querySelector('[data-lux-qty-plus]');
  if (minus) minus.addEventListener('click', function () { setQty(qty - 1); });
  if (plus) plus.addEventListener('click', function () { setQty(qty + 1); });

  var ACCORDION_SECTIONS = [
    { id: 'description', label: 'Description', match: null },
    { id: 'key-benefits', label: 'Key Benefits', match: /key\s*benefits?|^benefits?$|how\s+it\s+works|why\s+it\s+works/i },
    { id: 'features', label: 'Features', match: /^features?$|what['']?s\s+included|in\s+the\s+box|what['']?s\s+in\s+the\s+box/i },
    { id: 'specs', label: 'Specs', match: /^specs?$|^specifications?|^technical(\s+specs?)?$|^product\s+specs?$|dimensions|weight/i },
    { id: 'shipping', label: 'Shipping', match: /^shipping|^delivery|^returns?/i },
    { id: 'faq', label: 'FAQ', match: /^faq|frequently\s*asked|questions?\s*&\s*answers?/i }
  ];

  var BANNED_COPY_PATTERNS = [
    /FSA\s*\/?\s*HSA/gi,
    /clinically\s+(tested|validated|proven|reviewed|tuned)/gi,
    /clinical(?:ly)?\s+(grade|stud(?:y|ies)|trial|validation|light)/gi,
    /medical[\s-]grade/gi,
    /FDA[\s-]*(approved|certified|cleared)/gi,
    /\btherapeutic\s+grade\b/gi,
    /2[\s-]*year\s+warranty/gi,
    /manufacturer\s+(covered|warranty)/gi,
    /peer[\s-]*reviewed/gi,
    /scientifically\s+proven/gi,
    /neuroscientist/gi,
    /\bsurgeon\b/gi,
    /30[\s-]*night/gi,
    /risk[\s-]*free\s+trial/gi,
    /pre[\s-]*tax\s+benefits/gi,
    /healthcare\s+savings/gi,
    /\bForbes\b/gi,
    /endorsed\s+by/gi,
    /doctor[\s-]*recommended/gi,
    /Buy\s+One,?\s+Get\s+One/gi,
    /\bBOGO\b/gi,
    /50%\s*OFF/gi,
    /Editor'?s\s+Choice/gi,
    /cellular\s+repair/gi,
    /cardiovascular\s+health/gi,
    /occupational\s+hazard/gi
  ];

  function scrubBrandText(text) {
    if (!text) return '';
    var out = text;
    BANNED_COPY_PATTERNS.forEach(function (pattern) {
      out = out.replace(pattern, '');
    });
    return out
      .replace(/\s{2,}/g, ' ')
      .replace(/^[·•,\s\-–|]+|[·•,\s\-–|]+$/g, '')
      .trim();
  }

  function scrubBrandTextInPlace(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(function (node) {
      node.textContent = scrubBrandText(node.textContent);
    });
  }

  function sanitizeBrandNode(node) {
    if (!node) return;
    if (node.nodeType === Node.TEXT_NODE) {
      node.textContent = scrubBrandText(node.textContent);
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    Array.prototype.slice.call(node.childNodes).forEach(sanitizeBrandNode);

    if (/^(P|LI|SPAN|STRONG|EM|H[234]|DT|DD)$/i.test(node.tagName)) {
      var remaining = scrubBrandText(node.textContent);
      if (!remaining || remaining.length < 2) node.remove();
    }
  }

  function sanitizeBrandContent(root) {
    if (!root) return;
    sanitizeBrandNode(root);
    root.querySelectorAll('li, p').forEach(function (el) {
      if (!scrubBrandText(el.textContent)) el.remove();
    });
  }

  function isHeading(node) {
    return node && /^H[1-4]$/.test(node.tagName);
  }

  function normalizeHeading(text) {
    return (text || '')
      .replace(/\s+/g, ' ')
      .replace(/[:–—-]\s*$/, '')
      .trim();
  }

  function matchSectionKey(text) {
    var normalized = normalizeHeading(text);
    if (/^description$/i.test(normalized)) return 'description';
    for (var i = 1; i < ACCORDION_SECTIONS.length; i += 1) {
      var section = ACCORDION_SECTIONS[i];
      if (section.match && section.match.test(normalized)) return section.id;
    }
    return null;
  }

  function unwrapDescriptionNodes(nodes) {
    var list = nodes.slice();
    var guard = 0;
    while (list.length === 1 && /^DIV|SECTION|ARTICLE$/i.test(list[0].tagName) && guard < 6) {
      var inner = Array.prototype.slice.call(list[0].children);
      if (!inner.length) break;
      list = inner;
      guard += 1;
    }
    return list;
  }

  function firstBoldHeaderKey(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return null;
    var strong = node.querySelector(':scope > strong, :scope > b, :scope > span > strong, :scope > span > b');
    if (!strong) return null;
    return matchSectionKey(normalizeHeading(strong.textContent));
  }

  function resolveSectionHeader(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return null;

    var normalized = normalizeHeading(node.textContent);
    if (!normalized) return null;

    if (isHeading(node)) {
      return matchSectionKey(normalized);
    }

    if (!/^P|DIV|SPAN$/i.test(node.tagName)) return null;

    var boldKey = firstBoldHeaderKey(node);
    if (boldKey) return boldKey;

    var key = matchSectionKey(normalized);
    if (!key) return null;
    if (normalized.length > 64) return null;
    if (node.querySelector('img, table, ul, ol')) return null;

    var boldEls = node.querySelectorAll('strong, b');
    if (boldEls.length) {
      var boldText = normalizeHeading(
        Array.prototype.map.call(boldEls, function (el) {
          return el.textContent;
        }).join(' ')
      );
      if (boldText === normalized || normalized.indexOf(boldText) === 0) return key;
      return null;
    }

    var meaningful = Array.prototype.filter.call(node.childNodes, function (child) {
      return !(child.nodeType === Node.TEXT_NODE && !child.textContent.trim());
    });
    if (meaningful.length <= 1) return key;

    return null;
  }

  function createEl(tag, className) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    return el;
  }

  function enhanceContent(contentEl) {
    contentEl.querySelectorAll('ul').forEach(function (list) {
      list.classList.add('lux-acc__list');
    });
    contentEl.querySelectorAll('h3, h4').forEach(function (heading) {
      heading.classList.add('lux-acc__subhead');
    });
    contentEl.querySelectorAll('p > strong:only-child').forEach(function (strong) {
      var para = strong.parentElement;
      if (para && para.tagName === 'P') {
        para.classList.add('lux-acc__lead');
      }
    });
  }

  function buildFaqContent(nodes) {
    var wrap = createEl('div', 'lux-acc__faq');
    var index = 0;

    while (index < nodes.length) {
      var node = nodes[index];
      var question = '';

      if (isHeading(node)) {
        question = normalizeHeading(node.textContent);
        index += 1;
      } else if (node.tagName === 'P' && node.querySelector('strong')) {
        question = normalizeHeading(node.querySelector('strong').textContent);
        index += 1;
      } else {
        index += 1;
        continue;
      }

      if (!question) continue;

      var item = createEl('div', 'lux-acc__faq-item');
      var trigger = createEl('button', 'lux-acc__faq-q');
      trigger.type = 'button';
      trigger.setAttribute('aria-expanded', 'false');
      trigger.innerHTML = question + '<span class="lux-acc__faq-icon" aria-hidden="true"></span>';

      var answer = createEl('div', 'lux-acc__faq-a');
      answer.setAttribute('aria-hidden', 'true');
      var answerInner = createEl('div', 'lux-acc__faq-a-inner');

      if (index < nodes.length && nodes[index].tagName === 'P') {
        answerInner.innerHTML = nodes[index].innerHTML;
        index += 1;
      }

      answer.appendChild(answerInner);

      item.appendChild(trigger);
      item.appendChild(answer);
      wrap.appendChild(item);
    }

    return wrap;
  }

  function parseDescriptionIntoBuckets(nodes) {
    var buckets = {};
    ACCORDION_SECTIONS.forEach(function (section) {
      buckets[section.id] = [];
    });

    var currentKey = 'description';
    var index = 0;

    while (index < nodes.length) {
      var node = nodes[index];
      var sectionKey = resolveSectionHeader(node);
      if (sectionKey) {
        currentKey = sectionKey;
        index += 1;
        continue;
      }
      buckets[currentKey].push(node);
      index += 1;
    }

    return buckets;
  }

  function setAccordionItemState(item, open) {
    var trigger = item.querySelector('[data-lux-acc-trigger]');
    var panel = item.querySelector('[data-lux-acc-panel]');
    if (!trigger || !panel) return;
    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function closeAllAccordionItems(acc) {
    acc.querySelectorAll('[data-lux-acc-item]').forEach(function (item) {
      setAccordionItemState(item, false);
    });
  }

  function bindFaqItems(container) {
    container.querySelectorAll('.lux-acc__faq-item').forEach(function (item) {
      var btn = item.querySelector('.lux-acc__faq-q');
      var answer = item.querySelector('.lux-acc__faq-a');
      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        container.querySelectorAll('.lux-acc__faq-item').forEach(function (other) {
          other.classList.remove('is-open');
          var otherBtn = other.querySelector('.lux-acc__faq-q');
          var otherAnswer = other.querySelector('.lux-acc__faq-a');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          if (otherAnswer) otherAnswer.setAttribute('aria-hidden', 'true');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          answer.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }

  function appendAccordionSection(acc, section, sectionNodes, open) {
    var item = createEl('div', 'lux-acc__item');
    item.setAttribute('data-lux-acc-item', section.id);

    var heading = createEl('h3', 'lux-acc__heading');
    var trigger = createEl('button', 'lux-acc__trigger');
    trigger.type = 'button';
    trigger.setAttribute('data-lux-acc-trigger', '');
    trigger.id = 'lux-acc-trigger-' + section.id;
    trigger.setAttribute('aria-controls', 'lux-acc-panel-' + section.id);
    trigger.setAttribute('aria-expanded', 'false');
    trigger.innerHTML =
      '<span class="lux-acc__label">' + section.label + '</span>' +
      '<span class="lux-acc__icon" aria-hidden="true"></span>';

    heading.appendChild(trigger);
    item.appendChild(heading);

    var panelWrap = createEl('div', 'lux-acc__panel-wrap');
    var panel = createEl('div', 'lux-acc__panel');
    panel.setAttribute('data-lux-acc-panel', '');
    panel.id = 'lux-acc-panel-' + section.id;
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-labelledby', trigger.id);
    panel.setAttribute('aria-hidden', 'true');

    var content = createEl('div', 'lux-acc__content rte');

    if (section.id === 'faq') {
      content.appendChild(buildFaqContent(sectionNodes));
      bindFaqItems(content);
    } else {
      sectionNodes.forEach(function (node) {
        content.appendChild(node.cloneNode(true));
      });
      enhanceContent(content);
    }

    scrubBrandTextInPlace(content);

    if (!content.textContent || !content.textContent.trim()) return false;

    panel.appendChild(content);
    panelWrap.appendChild(panel);
    item.appendChild(panelWrap);
    acc.appendChild(item);

    if (open) setAccordionItemState(item, true);
    return true;
  }

  function bindAccordionTriggers(acc) {
    acc.querySelectorAll('[data-lux-acc-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-lux-acc-item]');
        var accRoot = trigger.closest('[data-lux-acc]');
        if (!item || !accRoot) return;
        var isOpen = item.classList.contains('is-open');
        closeAllAccordionItems(accRoot);
        if (!isOpen) setAccordionItemState(item, true);
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          trigger.click();
        }
      });
    });
  }

  function buildProductAccordion() {
    var acc = pdp.querySelector('[data-lux-acc]');
    var source = pdp.querySelector('[data-lux-desc-source]');
    if (!acc || acc.dataset.luxAccBuilt) return;

    var nodes = unwrapDescriptionNodes(
      source ? Array.prototype.slice.call(source.children) : []
    );

    if (!nodes.length && source && source.innerHTML.trim()) {
      var wrapper = document.createElement('div');
      wrapper.innerHTML = source.innerHTML;
      nodes = unwrapDescriptionNodes(Array.prototype.slice.call(wrapper.children));
      if (!nodes.length) {
        var fallbackPara = document.createElement('div');
        fallbackPara.className = 'rte';
        fallbackPara.innerHTML = source.innerHTML;
        nodes = [fallbackPara];
      }
    }
    var buckets = parseDescriptionIntoBuckets(nodes);

    var shippingFallback = pdp.querySelector('[data-lux-shipping-fallback]');
    if (shippingFallback && !buckets.shipping.length) {
      var temp = document.createElement('div');
      temp.innerHTML = shippingFallback.innerHTML;
      sanitizeBrandContent(temp);
      buckets.shipping = Array.prototype.slice.call(temp.children);
    }

    acc.dataset.luxAccBuilt = '1';
    acc.innerHTML = '';

    var firstOpenSet = false;

    ACCORDION_SECTIONS.forEach(function (section) {
      var sectionNodes = buckets[section.id] || [];
      if (!sectionNodes.length) return;
      var opened = appendAccordionSection(acc, section, sectionNodes, !firstOpenSet);
      if (opened) firstOpenSet = true;
    });

    if (!acc.children.length && nodes.length) {
      appendAccordionSection(
        acc,
        ACCORDION_SECTIONS[0],
        nodes,
        true
      );
    }

    bindAccordionTriggers(acc);

    var emptyEl = pdp.querySelector('[data-lux-desc-empty]');
    if (emptyEl) emptyEl.hidden = acc.children.length > 0;
  }

  buildProductAccordion();

  var descAtc = pdp.querySelector('[data-lux-desc-atc]');
  if (descAtc) {
    descAtc.addEventListener('click', function () {
      var target = atcBtn || form;
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (atcBtn && !atcBtn.disabled) {
          window.setTimeout(function () { atcBtn.focus(); }, 400);
        }
      }
    });
  }

  /* Sticky ATC */
  var stickyBtn = pdp.querySelector('[data-lux-sticky-submit]');
  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () {
      if (atcBtn && !atcBtn.disabled) atcBtn.click();
    });
  }
})();
